exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".data-source-tree[data-v-500aea82]::-webkit-scrollbar{width:6px}", ""]);

// exports
